'use strict';

import React, { useRef, useEffect, useState } from 'react';
import uniqid from 'uniqid';
import Button from '@material-ui/core/Button';
import FullScreenModal from 'Modals/FullScreenModal';
import Slider from 'Components/Slider';
import { etablishment as etablishment_icons } from 'Components/IconsConfigs';
import Image from 'Pure/Image';
import Link from 'Pure/Link';
import PhoneIcon from 'Icons/Phone';
import PhotoIcon from 'Icons/PhotoIcon';
import isInViewport from 'Functions/isInViewport';
import variant from 'Functions/variant';
import bemit from 'Functions/bemit';
import { etablishment_equipments, coworking_place_types } from 'Shared/options';
import { getSpacedPhoneNumber } from 'Shared/utilities';
import { URL } from 'Shared/Routes';
const {
  app
} = window;
export default function EtablishmentRecap(props) {
  const link_ref = useRef(null);
  const [slider_modal, setSliderModal] = useState({});
  const [slider_imgs, setSliderImgs] = useState();
  useEffect(() => {
    scrollBlockIntoView();
  }, []); // on mount

  useEffect(() => {
    scrollBlockIntoView();
    let slider_imgs = (etablishment.images || []).map(function (image) {
      let data = {
        alt: image.alt || image.title,
        src: variant({
          img: image,
          size: 1920,
          ratio: '16:9'
        }),
        id: uniqid()
      };
      return data;
    });
    if (slider_imgs.length > 1) {
      setSliderImgs(slider_imgs);
    } else if (slider_imgs) {
      setSliderImgs(undefined);
    }
  }, [props.data.id]); // on etablishment change

  const {
    data: etablishment
  } = props;
  const image_url = variant({
    img: etablishment.images?.[0],
    size: 600
  });
  const icons = etablishment_equipments.filter(infos => (etablishment.service || []).includes(infos.value)).map(function (infos) {
    const icons_info = etablishment_icons.find(data => data.value === infos.value);
    if (!icons_info) return null;
    const Icon = icons_info.icon;
    const output = /*#__PURE__*/React.createElement("li", {
      className: "c-media__icon has-gap",
      key: infos.value
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "c-media__icon-svg"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-media__icon-label"
    }, infos.label || infos.value));
    return output;
  });
  const space_types = coworking_place_types.filter(function (opt) {
    return (etablishment.__spaces || []).some(space => space.type === opt.value);
  }).map(function (opt) {
    const output = /*#__PURE__*/React.createElement("div", {
      className: "c-etablishment-recap__space-type",
      key: opt.value
    }, opt.label.split('myWO')[1]);
    return output;
  });
  const phone_number = etablishment.phone_number ? /*#__PURE__*/React.createElement("a", {
    onClick: onPhoneClick,
    className: bemit('c-infos-label', ['phone-number']),
    href: 'tel:' + etablishment.phone_number.split(' ').join('')
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-infos-label__title",
    "data-mobile-label": "Appeler"
  }, /*#__PURE__*/React.createElement(PhoneIcon, {
    className: "c-infos-label__icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "c-infos-label__title-txt"
  }, "T\xE9l\xE9phone")), /*#__PURE__*/React.createElement("span", {
    className: "c-infos-label__txt"
  }, getSpacedPhoneNumber(etablishment.phone_number))) : undefined;
  const etablishment_href = URL('FrontEtablishmentPage').replace(':slug', etablishment.slug);
  const output = /*#__PURE__*/React.createElement("div", {
    className: "c-etablishment-recap",
    key: etablishment.id
  }, /*#__PURE__*/React.createElement(Image, {
    className: "c-etablishment-recap__img",
    src: image_url,
    alt: etablishment.name
  }), slider_imgs ? /*#__PURE__*/React.createElement("div", {
    className: "c-etablishment-recap__galerie"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "c-etablishment-recap__galerie-btn",
    onClick: e => setSliderModal({
      open: true,
      trg: e?.target
    })
  }, /*#__PURE__*/React.createElement(PhotoIcon, {
    className: "c-front-page-intro__address-icon"
  }), "Galerie")) : undefined, /*#__PURE__*/React.createElement("h3", {
    className: "c-etablishment-recap__title"
  }, /*#__PURE__*/React.createElement(Link, {
    href: etablishment_href,
    className: "c-etablishment-recap__title-link"
  }, etablishment.name)), /*#__PURE__*/React.createElement("div", {
    className: "c-etablishment-recap__infos"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-etablishment-recap__column"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "c-etablishment-recap__subtitle"
  }, "Contact"), phone_number), /*#__PURE__*/React.createElement("div", {
    className: "c-etablishment-recap__column"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "c-etablishment-recap__subtitle"
  }, "Espaces propos\xE9s"), /*#__PURE__*/React.createElement("ul", {
    className: "c-etablishment-recap__spaces-types"
  }, space_types)), /*#__PURE__*/React.createElement("div", {
    className: "c-etablishment-recap__row"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "c-etablishment-recap__subtitle"
  }, "Services"), /*#__PURE__*/React.createElement("ul", {
    className: "c-etablishment-recap__services"
  }, icons))), /*#__PURE__*/React.createElement("div", {
    className: "u-full-width u-text-center u-margin-top-20"
  }, /*#__PURE__*/React.createElement(Link, {
    href: etablishment_href,
    className: bemit('c-flat-btn', ['blue', 'v2', 'map-details-btn']) + ' u-margin-bottom-30',
    "dom-ref": link_ref
  }, "Voir les disponibilit\xE9s")), /*#__PURE__*/React.createElement(FullScreenModal, {
    open: slider_modal.open === true,
    onClose: e => setSliderModal({}),
    trigger_src: slider_modal.trg
  }, slider_imgs ? /*#__PURE__*/React.createElement("div", {
    className: "c-front-page-intro__slider-container"
  }, /*#__PURE__*/React.createElement(Slider, {
    images: slider_imgs,
    bemit: ['fill-height'],
    "with-overlay": true
  })) : undefined));
  return output;
  function onPhoneClick(e) {
    e.persist();
    app.emit({
      event: 'TC_Click',
      source: 'EtablishmentRecap',
      data: {
        e: e,
        action: 'contacter_etablissement'
      }
    });
  }
  function scrollBlockIntoView() {
    if (props['auto-scroll'] !== true) return;
    if (link_ref?.current && !isInViewport(link_ref?.current)) {
      window.setTimeout(function () {
        window.requestAnimationFrame(function () {
          const block = window.innerWidth > 900 ? getBlockElement(link_ref.current) : link_ref.current?.parentElement;
          if (!block) return;
          block.scrollIntoView({
            behavior: 'smooth',
            block: 'end'
          });
        });
      }, 100);
    }
  }
  function getBlockElement(link) {
    let node = link.parentElement;
    const block_class = 'c-map-details-block';
    while (node.parentElement && !node.className.includes(block_class)) {
      node = node.parentElement;
    }
    return node;
  }
}
